import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgRadioIcon = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 16 16"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <circle
      cx={8}
      cy={8}
      r={7.5}
      fill="url(#radio-icon-paint0_linear_755_1578)"
      stroke="#C9C9C9"
    />
    <defs>
      <linearGradient
        id="radio-icon-paint0_linear_755_1578"
        x1={12}
        x2={4.5}
        y1={14.5}
        y2={3.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F8F8F" />
        <stop offset={1} stopColor="#1E1E1E" />
      </linearGradient>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgRadioIcon);
const Memo = memo(ForwardRef);
export default Memo;
